export const selectTheme = {
  colorScheme: {
    light: {
      root: {
        background: 'transparent',
        disabledBackground: '{gray.200}',
        borderColor: 'var(--surface-stroke-divider-formfield)',
        hoverBorderColor: 'var(--surface-stroke-divider-formfield)',
        focusBorderColor: 'var(--surface-accent-main)',
        invalidBorderColor: 'var(--danger)',
        color: 'var(--text-primary)',
        disabledColor: 'var(--text-decent)',
        placeholderColor: 'var(--text-decent)'
      },
      overlay: {
        background: 'var(--surface-fill)',
        borderColor: 'var(--surface-accent-main)',
        color: 'var(--text-primary)'
      },
      option: {
        focusBackground: 'rgba(128, 128, 128, 0.1)',
        selectedBackground: 'rgba(128, 128, 128, 0.2)',
        selectedFocusBackground: 'rgba(128, 128, 128, 0.25)',
        color: 'var(--text-primary)',
        focusColor: 'var(--text-primary)',
        selectedColor: 'var(--text-primary)',
        selectedFocusColor: 'var(--text-primary)',
        selectedCheckboxColor: 'var(--text-primary)'
      }
    },
    dark: {
      root: {
        background: 'transparent',
        disabledBackground: 'var(--bg-grey-7)',
        borderColor: 'var(--surface-stroke-divider-formfield)',
        hoverBorderColor: 'var(--surface-stroke-divider-formfield)',
        focusBorderColor: 'var(--surface-accent-main)',
        invalidBorderColor: 'var(--danger)',
        color: 'var(--text-primary)',
        disabledColor: 'var(--text-decent)',
        placeholderColor: 'var(--text-decent)'
      },
      overlay: {
        background: 'var(--surface-fill)',
        borderColor: 'var(--surface-accent-main)',
        color: 'var(--text-primary)'
      },
      option: {
        focusBackground: 'rgba(128, 128, 128, 0.1)',
        selectedBackground: 'rgba(128, 128, 128, 0.2)',
        selectedFocusBackground: 'rgba(128, 128, 128, 0.25)',
        color: 'var(--text-primary)',
        focusColor: 'var(--text-primary)',
        selectedColor: 'var(--text-primary)',
        selectedFocusColor: 'var(--text-primary)',
        selectedCheckboxColor: 'var(--text-primary)'
      }
    }
  }
};
